/**
 * Engine configuration constants
 */

/** 
 * Size threshold for materializing tables vs creating views in DuckDB WASM.
 * Tables smaller than this will be materialized (downloaded and cached),
 * larger tables will be created as views for streaming.
 * 
 * This is specifically for DuckDB WASM performance optimization since
 * CREATE TABLE AS SELECT operations are slow in single-threaded WASM.
 */
export const DUCKDB_WASM_MATERIALIZATION_THRESHOLD_BYTES = 50 * 1024 * 1024; // 50MB 